<template>
    <Widget title="Guess Data" :area="this.$props.area">
        <GuessWords/>
        <GuessSubs/>
        <GuessGames/>
        <!--    TODO guess country-->
        <!--    TODO guess fav sport/team-->
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";
    import GuessWords from "./guess/GuessWords";
    import GuessSubs from "./guess/GuessSubs";
    import GuessGames from "./guess/GuessGames";

    export default {
        components: {GuessGames, NameValue, Widget, GuessWords, GuessSubs},
        props: {area: String},
        computed: {
            ...mapGetters(['user', 'allPosts', 'comments', 'submissions']),
        },
        methods: {
            open() {
            }
        }
    }
</script>

<style scoped>

</style>
